import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import compare from './compare/index';
import availability from './availability/index';
import views from './views/index';

const state = {
  list: [],
  floorList: [],
  filters: {
    searchString: '',
    typeList: [],
    exposureList: [],
    bathList: [],
    sqftRange: {
      min: 0,
      max: 9999,
      default: {
        min: 0,
        max: 9999
      }
    },
    floorRange: {
      min: 0,
      max: 99,
      default: {
        min: 0,
        max: 99
      }
    },
    sortBy: {
      type: 'sqft',
      asc: true
    },
    collectionList: [
      {
        label: 'City Scape',
        slug: 'cityscape',
        active: false
      },
      {
        label: 'Sea Loge',
        slug: 'sealoge',
        active: false
      },
      {
        label: 'Summer Wind',
        slug: 'summerwind',
        active: false
      },
      {
        label: 'Skye',
        slug: 'skye',
        active: false
      },
    ],
  },
  favouritedIdList: [],
  showFavourites: false,
  listDisplayType: 'grid',
  selectedUnitName: '',
  collectionMapping: {
    cityscape: [
      '1A Level 2',
      '1A Level 3-6',
      '1B Level 3-6',
      '1C-BF Level 3-6',
      '1D Level 3-6',
      '1E Level 3-6',
      '1F-BF Level 7-9',
      '1F Level 7-9 (A)',
      '1F Level 7-9 (B)',
      '1F Level 6-9 (C)',
      '1F Level 10 (A)',
      '1F Level 10 (B)',
      '1F Level 10 (C)',
      '1F Level 10 (D)',
      '1J Level 7-9',
      '1K Level 7-9',
      '1L Level 7-9',
      '1L Level 10',
      '1M Level 7-9',
      '1M Level 10',
      '1N Level 7-10',
      '1P Level 3-6',
      '1Q Level 3-6',
      '2F Level 2',
      '2F Level 3-6',
      '2X Level 10'
    ],
    sealoge: [
      '1G Level 2-4',
      '1H Level 2-4',
      '1R Level 2-4',
      '1S Level 2-4',
      '1U Level 2-4',
      '2E Level 2-4',
      '2G Level 5',
      '2G Level 6-9',
      '2G Level 10',
      '2H Level 5',
      '2H Level 6-9',
      '2H Level 10',
      '2HA Level 5',
      '2HA Level 6-9',
      '2HA Level 10',
      '2J Level 5',
      '2J Level 6-9',
      '2J Level 10'
    ],
    summerwind: [
      '2K Level 6-9',
      '2Q Level 6-9',
      '2W Level 10',
      '3C Level 10'
    ],
    skye: [
      '2L Level 6',
      '2M Level 6',
      '2N Level 6-9',
      '2P Level 6',
      '2T Level 7',
      '2Y Level 8-9',
      '3A Level 6',
      '3B Level 7-9 (A)',
      '3B Level 7-9 (B)',
      '3D Level 7-9'
    ]
  }
};

export default {
  namespaced: true,
  modules: {
    compare,
    availability,
    views
  },
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/index.js